export default function CustomInput({
  className = 'bg-input-gray text-gray-accent',
  label,
  type,
  placeholder,
  isError = false,
  value,
  onChangeHandler,
  ...props
}) {
  const borderStyle = () => {
    if (value.length > 0) {
      return isError
        ? 'border-red-accent focus:border-red-accent'
        : 'border-gray-accent focus:border-gray-accent'
    }
    return isError
      ? 'border-red-accent focus:border-red-accent'
      : 'border-gray-400 hover:border-gray-500 focus:border-gray-accent'
  }
  return (
    <div className="flex items-center justify-center gap-3 text-lg">
      <label
        htmlFor={label} //
        className="flex items-center text-nowrap text-center text-gray-700"
      >
        {label}:
      </label>
      <input
        id={label}
        type={type}
        placeholder={placeholder}
        className={`${className} text-md peer box-border block min-h-[auto] w-full rounded border-2 px-3 py-2 outline-none transition-all duration-200 ease-linear sm:text-lg ${borderStyle()} peer-focus:text-primary focus:outline-none focus:ring-0 focus:placeholder:opacity-0`}
        value={value}
        onChange={onChangeHandler}
        {...props}
      />
    </div>
  )
}
